export default __webpack_public_path__ + "static/media/ad_2.765df9bf.mp3";